import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'roles'
})

export class RolesPipe implements PipeTransform {
    transform(value: string | number, type: any) {

        let val: any;
        switch (type) {
            case 'role':
                if (!value || value === '0' || value === 'false') {
                    val = 'No';
                } else if (value === '1' || value === 'true') {
                    val = 'Yes';
                } else if (value === '') {
                    val = 'N/A';
                }
                break;
            default:
                val = value;
                break;
        }
        if (type === 'Officer title') {
            if (!value || value === '') {
                val = 'N/A';
            }
        }

        return val;
    }
}
